import moment from 'moment'
// making this reusable
// event span in hours from start/end
export function computeEventDurationHours(event) {
  if (!event?.event_start_date || !event?.event_end_date) return null
  const start = moment(event.event_start_date)
  const end = moment(event.event_end_date)
  if (!start.isValid() || !end.isValid()) return null
  const hours = end.diff(start) / 3600000
  if (!Number.isFinite(hours) || hours <= 0) return null
  return parseFloat(hours.toFixed(2))
}

// volunteers_needed × event duration
export function computeEstimatedVolunteerHours(event) {
  const volunteers = Number(event?.volunteers_needed) || 0
  const durationHours = computeEventDurationHours(event)
  if (!volunteers || durationHours == null) return null
  return parseFloat((volunteers * durationHours).toFixed(2))
}

export function formatEstimatedVolunteerHours(hours) {
  if (hours == null || !Number.isFinite(hours)) return null
  return Number.isInteger(hours) ? hours : parseFloat(hours.toFixed(1))
}
